export const MX_EXTRAS_DENTAL_CHEW_PRODUCT_CODE = 'DC';
export const MX_EXTRAS_TREAT_PRODUCT_CODE = 'TRT';
export const MX_EXTRAS_SUPPLEMENT_PRODUCT_CODE = 'SPPL';
export const MX_EXTRAS_PRODUCT_CODES = [
  MX_EXTRAS_TREAT_PRODUCT_CODE,
  MX_EXTRAS_SUPPLEMENT_PRODUCT_CODE,
  MX_EXTRAS_DENTAL_CHEW_PRODUCT_CODE,
];

// Error Messages
export const MX_EXTRAS_NO_PET_FOUND_ERROR_MESSAGE = 'No pet found';
export const MX_EXTRAS_INVALID_PAYLOAD_ERROR_MESSAGE = 'Invalid payload';
export const MX_EXTRAS_ENTITY_ERRORS_ERROR_MESSAGE = 'Entity errors';
export const MX_EXTRAS_NO_COHORT_FOUND_ERROR_MESSAGE = 'No cohort found';
export const MX_EXTRAS_SUBSCRIPTION_NOT_FOUND_ERROR_MESSAGE =
  'Subscription not found';
export const MX_EXTRA_NOT_FOUND_ERROR_MESSAGE =
  'Extra not found on subscription';

// Extras Example
export const MX_TREAT = {
  sku: 'TRT-JERKY-BSP',
  name: 'Beef Jerky',
  description: 'Beef Jerky',
  product_code: 'TRT',
  product_category: 'Treats',
  is_recommended: true,
  price: '25.00',
};

export const MX_DENTAL_CHEW = {
  sku: 'DC-DENTALCHEWS-SM',
  name: 'Dental Chews',
  description: 'Dental Chews',
  product_code: 'DC',
  product_category: 'Dental Chews',
  is_recommended: true,
  price: '25.00',
};

export const MX_SUPPLEMENT = {
  sku: 'SPPL-CHILLPILLS',
  name: 'Chill Pills',
  description: 'Chill Pills',
  product_code: 'SPPL',
  product_category: 'Supplements',
  is_recommended: true,
  price: '25.00',
};

export const MX_EXTRAS = [MX_TREAT, MX_SUPPLEMENT, MX_DENTAL_CHEW];

export const makeExtra = override => ({
  sku: 'DC-DENTALCHEWS-SM',
  name: 'Dental Chews SM',
  description: 'Dental Chews SM',
  product_code: 'DC',
  product_category: 'Dental Chews',
  is_recommended: false,
  price: '25.00',
  ...override,
});

export const subscriptionId = 'UUID';
export const extraId = 'UUID';

export const BC_TO_SHOPIFY_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'JERKYSTRIPS-BE': 'TRT-JERKYSTRIPS-BSP',
  /* Chicken and Apple Jerky Strips */
  'JERKYSTRIPS-CH': 'TRT-JERKYSTRIPS-CA',
  /* Salmon and Coconut Jerky Strips */
  'JERKYSTRIPS-SA': 'TRT-JERKYSTRIPS-SC',
  /* Peanut Butter Frozen Treat */
  'FR-ICECREAM-PBB': 'TRT-FROZENTREAT-PB',
  /* Crunchy Treats with Sweet Potato */
  'TREAT-SWEETPOTATOCRNCH-08': 'TRT-CRUNCHY-SP',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TREAT-APPLECRNCH-08': 'TRT-CRUNCHY-AMB',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': '',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': '',
  /* Skin & Coat Chews */
  'SUPP-SKIN': 'SPPL-SKINCOAT',
  /* Probiotic Chews */
  BELLYRUBS01: 'SPPL-PROBIOTIC',
  /* Hip & Joint Chews */
  ZOOMIES01: 'SPPL-HIPJOINT',
  /* Calming Chews */
  CHILLPILLS01: 'SPPL-CALMING',
  /* Dental Chews */
  'SUPP-DENT-XS': 'DC-DENTALCHEWS-XS',
  'SUPP-DENT-SM': 'DC-DENTALCHEWS-SM',
  'SUPP-DENT-MD': 'DC-DENTALCHEWS-MD',
  'SUPP-DENT-LG': 'DC-DENTALCHEWS-LG',
};

// this is used to add legacySku to Shopify extras
// and in turn be able to map accurately to the CMS
export const SHOPIFY_TO_BC_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'TRT-JERKYSTRIPS-BSP': 'JERKYSTRIPS-BE',
  /* Chicken and Apple Jerky Strips */
  'TRT-JERKYSTRIPS-CA': 'JERKYSTRIPS-CH',
  /* Salmon and Coconut Jerky Strips */
  'TRT-JERKYSTRIPS-SC': 'JERKYSTRIPS-SA',
  /* Peanut Butter Frozen Treat */
  'TRT-FROZENTREAT-PB': 'FR-ICECREAM-PBB',
  /* Crunchy Treats with Sweet Potato */
  'TRT-CRUNCHY-SP': 'TREAT-SWEETPOTATOCRNCH-08',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TRT-CRUNCHY-AMB': 'TREAT-APPLECRNCH-08',
  /* Skin & Coat Chews */
  'SPPL-SKINCOAT': 'SUPP-SKIN',
  /* Probiotic Chews */
  'SPPL-PROBIOTIC': 'BELLYRUBS01',
  /* Hip & Joint Chews */
  'SPPL-HIPJOINT': 'ZOOMIES01',
  /* Calming Chews */
  'SPPL-CALMING': 'CHILLPILLS01',
  /* Dental Chews */
  'DC-DENTALCHEWS-XS': 'SUPP-DENT-XS',
  'DC-DENTALCHEWS-SM': 'SUPP-DENT-SM',
  'DC-DENTALCHEWS-MD': 'SUPP-DENT-MD',
  'DC-DENTALCHEWS-LG': 'SUPP-DENT-LG',
};
